export const COLORS = {
  bgColor: '#f7f7f7',
  bgColorBlogs: '#F4F7FF',
  bgBlue: ' rgba(64, 119, 255, 0.10)',
  lightGray: '#9A9EA6',
  placeholder: '#9A9EA6',
  greenPrimary: '#1F9638',
  borderColor: '#E8ECF4',
  tableRowBackgroundColor: '#E7ECF5',
  textSecondary: '#676D75',
  borderDark: '#71767D',
  white: '#FFFFFF',
  black: '#000000',
  inputPlaceholderColor: '#A9ADB2',
  primary: '#004AE0',
  primaryDark: '#082B6E',
  dividerColor: 'rgba(0, 0, 0, 0.12)',
  applicationItemBorder: 'rgba(0, 0, 0, 0.20)',
  applicationItemBg: '#F9F9F9',
  skyBlue: '#4BB3FD',
  mustard: '#FFBA08',
  purple: '#802BFF',
  filtersColor: '#7F8184',
  textPrimary: '#252525',

  // institutional cards
  institutesSectionBg: '#FCFCFC',
  trustedPartnerTagDot: '#3076FE',
  highMeritTagDot: '#01C115',
  innovationHubTagDot: '#F97316',
  hybridModelTagDot: '#6A02B3',
  globalReachTagDot: '#C10865',
  trustedPartnerGlow: '#8EC5FF',
  highMeritGlow: '#8EC5FF',
  hybridModelGlow: '#C4B4FF',
  globalReachGlow: '#FFA1AD',
  // Program Card Specific
  uniTextOnImage: '#2C398A',
  uniNameGray: '#464A50',
  statusOpen: '#2BCC12',
  statusClosed: '#FF0000',
  statusClosingSoon: '#EABA1A',
  statusOpeningSoon: '#004AE0',
  statusNotAccepting: '#676D75',
  /** Deadline text once the date has passed (program + scholarship cards) */
  deadlineExpired: '#E00000',
  statusBgOpen: 'rgba(43, 204, 18, 0.05)',
  statusBgClosed: 'rgba(255, 0, 0, 0.05)',
  statusBgClosingSoon: 'rgba(247, 216, 59, 0.05)',
  statusBgOpeningSoon: 'rgba(0, 74, 224, 0.05)',
  statusBgNotAccepting: 'rgba(103, 109, 117, 0.05)',
  badgeHotStart: '#EE3535',
  badgeHotEnd: '#FC8302',
  badgeClosedStart: '#FA0A0A',
  badgeClosedEnd: '#F9402B',
  badgeCareerStart: '#51A2FF',
  badgeCareerMid: '#2B7FFF',
  badgeCareerEnd: '#4F39F6',
  badgeScholarshipStart: '#BB00E0',
  badgeScholarshipEnd: '#6902B2',
  badgeValueStart: '#00E061',
  badgeValueEnd: '#00C013',
  /** Program card title tooltip (ellipsis hover) */
  programCardTitleTooltipBg: '#E5EDFC',
  programCardTitleTooltipText: '#0B4586'
};
